<nav #stickyNav class="checkout-nav" [class._is_sticky]="isSticky">
    <div class="checkout-nav__inner-container">
        <a class="checkout-nav__logo-link" [href]="homeUrl">
            <mg-lighting-logo></mg-lighting-logo>
            <mg-visual-logo></mg-visual-logo>
        </a>

        <h1 class="checkout-nav__title">
            <ng-container *ngIf="titleVariant === 'default'">
                <span class="checkout-nav__title-main" i18n="@@configurator.nav-title.default.main"
                    >Configure your {{ modelName }}</span
                >
                <span class="checkout-nav__title-additional" i18n="@@configurator.nav-title.default.additional"
                    >in 4 straightforward steps</span
                >
            </ng-container>
            <ng-container *ngIf="titleVariant === 'confirm'">
                <span class="checkout-nav__title-main" i18n="@@configurator.nav-title.confirm.main"
                    >Configure your {{ modelName }}</span
                >
                <span class="checkout-nav__title-additional" i18n="@@configurator.nav-title.confirm.additional"
                    >the final details</span
                >
            </ng-container>
            <ng-container *ngIf="titleVariant === 'sales-advisor'">
                <span class="checkout-nav__title-main" i18n="@@configurator.nav-title.sales-advisor.main"
                    >Configure your {{ modelName }}</span
                >
            </ng-container>
        </h1>
    </div>
</nav>
